import {
  CWAccordionPanel,
  CWAccordionPanelContent,
  CWAccordionPanelHeader,
} from '@features/common.components/ComponentsWeb/Accordion'
import {
  CWHeading,
  CWHeadingHeader,
} from '@features/common.components/ComponentsWeb/Heading'
import { Link } from '@features/common.components/Link'
import { RateLimit } from '@features/faucet.constants'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'

/**
 * Type for a Faucet FAQ item.
 */
type FaucetFaqItem = {
  /**
   * The item title.
   */
  title: string
  /**
   * The item description.
   */
  description: string
  /**
   * The item's first link.
   */
  href?: string
  /**
   * The item's second link.
   */
  href2?: string
  /**
   * The item's third link.
   */
  href3?: string
}

export const FaqSection: React.FC = () => {
  const { t } = useTranslation('faucet')

  const faqItems: FaucetFaqItem[] = t('faq.items', null, {
    returnObjects: true,
  })

  return (
    <div className="size-full" data-testid="faucet-faq-section">
      <CWHeading size="md">
        <CWHeadingHeader className="type-header-md">
          {t`faq.header`}
        </CWHeadingHeader>
      </CWHeading>

      <div className="divide-neutral-subtle divide-y">
        {faqItems.map((item, index) => (
          <CWAccordionPanel key={item.title} className="py-3" onCard={false}>
            <CWAccordionPanelHeader>
              <div className="text-neutral-strong type-header-xs text-left">
                {item.title}
              </div>
            </CWAccordionPanelHeader>
            <CWAccordionPanelContent>
              <div className="text-neutral-strong type-body-base text-left">
                <Trans
                  components={{
                    a: <Link path={item.href ?? ''} type="external" />,
                    a2: <Link path={item.href2 ?? ''} type="external" />,
                    a3: <Link path={item.href3 ?? ''} type="external" />,
                    br: <br />,
                  }}
                  i18nKey={`faucet:faq.items.${index}.description`}
                  values={{ count: RateLimit.FAUCET_RATE_LIMIT_HOURS }}
                />
              </div>
            </CWAccordionPanelContent>
          </CWAccordionPanel>
        ))}
      </div>
    </div>
  )
}
